import { hasScopedPermission, GrantsType } from '../../Shared/utils/auth';

export const viewPartnerRole = (
  grants: GrantsType,
  currentPartner?: {
    ancestorIds: Array<string>;
  }
) => {
  const permission = 'partners.read';
  return (
    hasScopedPermission(grants, 'system', permission) ||
    grants.some((grant) => {
      return (
        grant.scope === 'partner' &&
        grant.scopeId === currentPartner?.ancestorIds[0] &&
        grant.permissions.includes(permission)
      );
    })
  );
};
